module.exports = __webpack_public_path__ + "img/Pacific.fbef97b4.png";